import type { SetPasswordSignupRoute } from "@/app/api/auth/set-password-signup/route";
import { postJson } from "@/utils/routeUtils";
import { mutationOptions } from "@tanstack/react-query";

type SetPasswordSignupInput = SetPasswordSignupRoute["input"];

export const setPasswordSignupMutationOptions = ({
  getTurnstileToken,
}: {
  getTurnstileToken: () => Promise<string | undefined>;
}) =>
  mutationOptions({
    mutationFn: async ({
      newPassword,
    }: Pick<SetPasswordSignupInput, "newPassword">) => {
      const captchaToken = await getTurnstileToken();
      if (!captchaToken) {
        throw new Error(
          "Security verification failed. Please refresh and try again."
        );
      }

      const result = await postJson(
        "/api/auth/set-password-signup",
        { newPassword, captchaToken },
        { skipLogs: true }
      );

      if (!result.success) {
        throw new Error(result.error ?? "Failed to create password");
      }

      return result.data;
    },
  });
